<template>
    <svg width="96" height="97" viewBox="0 0 96 97" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_6469_1498)">
            <path
                d="M60.5467 59.6185H29.4767L8.01051 71.9878C7.75492 72.135 7.46253 71.8637 7.59036 71.5978L13.5433 59.2169H11.1533C4.78 59.2169 0 53.9951 0 
                    47.97V11.4178C0 5.39265 5.17834 0.170898 11.1533 0.170898H60.5467C66.9201 0.170898 71.7001 5.39265 71.7001 11.4178V47.97C72.0984 54.3968 
                    66.9201 59.6185 60.5467 59.6185Z"
                fill="#00D672"
            />
            <path
                d="M86.0413 35.9199H75.6847V47.1668C75.6847 58.4136 68.9123 63.904 60.1488 63.904H35.4521L35.4529 75.6856C35.4529 80.9073 39.8347 85.3257 45.013 
                    85.3257H70.9047L88.7875 95.685C89.0427 95.8329 89.3358 95.5623 89.2087 95.2962L84.448 85.3257H86.4396C91.618 85.3257 95.9997 80.9073 95.9997 
                    75.6856V45.1584C95.6014 40.3383 91.2196 35.9199 86.0413 35.9199Z"
                fill="#06473C"
            />
            <path
                d="M19.9164 36.3212C23.2163 36.3212 25.8914 33.6237 25.8914 30.2961C25.8914 26.9686 23.2163 24.271 19.9164 24.271C16.6165 24.271 13.9414 26.9686 
                    13.9414 30.2961C13.9414 33.6237 16.6165 36.3212 19.9164 36.3212Z"
                fill="white"
            />
            <path
                d="M35.85 36.3212C39.1499 36.3212 41.825 33.6237 41.825 30.2961C41.825 26.9686 39.1499 24.271 35.85 24.271C32.5501 24.271 29.875 26.9686 29.875 
                    30.2961C29.875 33.6237 32.5501 36.3212 35.85 36.3212Z"
                fill="white"
            />
            <path
                d="M51.7836 36.3212C55.0835 36.3212 57.7586 33.6237 57.7586 30.2961C57.7586 26.9686 55.0835 24.271 51.7836 24.271C48.4837 24.271 45.8086 26.9686 
                    45.8086 30.2961C45.8086 33.6237 48.4837 36.3212 51.7836 36.3212Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_6469_1498">
                <rect width="96" height="96" fill="white" transform="translate(0 0.170898)" />
            </clipPath>
        </defs>
    </svg>
</template>
